import { useEffect } from 'react';

import { useAuthActions, useAuthModal } from 'authOld/hooks';
import { mapCreatePasswordForm } from 'authOld/mappers';
import { ICreatePasswordForm } from 'authOld/types';
import { HeaderModalOptions } from 'coreOld/constants';

import CreatePasswordFormView from './CreatePasswordFormView';
import { getModalInfoByType } from './utils';

interface IProps {
  onNext: (step: HeaderModalOptions) => void;
}

const CreatePasswordForm = ({ onNext }: IProps) => {
  const { openedAuthModal, parentAuthModal, closeAuthModal, setOpenedAsParentAuthModal } =
    useAuthModal();

  const { createPassword } = useAuthActions();

  useEffect(() => {
    setOpenedAsParentAuthModal(HeaderModalOptions.CREATE_PASSWORD);
  }, [openedAuthModal]);

  const onSubmit = () => async (data: ICreatePasswordForm) => {
    const { success } = await createPassword(mapCreatePasswordForm(data));

    if (success) {
      closeAuthModal();
    }

    if (parentAuthModal) {
      onNext(HeaderModalOptions.CREATE_PASSWORD);
    }
  };

  return (
    <CreatePasswordFormView
      isOpen={openedAuthModal === HeaderModalOptions.CREATE_PASSWORD}
      onClose={closeAuthModal}
      onSubmit={onSubmit}
      modalInfo={getModalInfoByType(parentAuthModal || undefined)}
    />
  );
};

export default CreatePasswordForm;
